/* eslint-disable camelcase */
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import { useEffect, useRef, useState } from 'react';
import { createTimeText, isInViewport } from '../utils';
import { useOutside } from '@hn-front/utils';
var useStuckStudents = function (weeklyData) {
    var _a;
    var _b = useState(false), showStuckPopup = _b[0], toggleStuckPopup = _b[1];
    var stuckStudents = (_a = weeklyData === null || weeklyData === void 0 ? void 0 : weeklyData.stuck_students) === null || _a === void 0 ? void 0 : _a.map(function (student) { return ({
        id: student.id + "_" + student.card_id,
        studentName: student.name,
        cardName: student.task_name,
        startDate: student.started_date,
        timeSpent: createTimeText(student.spent),
        timeSpentAverage: student.average_completion_time,
        accuracy: student.right_answers + "/" + student.total_answers + " (" + student.accuracy + "%)",
        studentLink: student.student_link,
        cardLink: student.card_link,
    }); });
    var showStuckStudents = stuckStudents.length > 0;
    var refStuckContainer = useRef(null);
    var refStuckPopup = useRef(null);
    useEffect(function () {
        if (showStuckStudents && !weeklyData.stuck_students_popup_seen) {
            toggleStuckPopup(true);
        }
    }, [showStuckStudents, weeklyData]);
    useEffect(function () {
        if (showStuckPopup) {
            disableBodyScroll(document.body, { reserveScrollBarGap: true });
            if (refStuckContainer.current &&
                !isInViewport(refStuckContainer.current)) {
                refStuckContainer.current.scrollIntoView();
            }
        }
        else {
            clearAllBodyScrollLocks();
        }
        return function () { return clearAllBodyScrollLocks(); };
    }, [showStuckPopup]);
    useOutside([refStuckContainer, refStuckPopup], function () {
        toggleStuckPopup(false);
    });
    return {
        stuckStudents: stuckStudents,
        showStuckStudents: showStuckStudents,
        showStuckPopup: showStuckPopup,
        toggleStuckPopup: toggleStuckPopup,
        refStuckContainer: refStuckContainer,
        refStuckPopup: refStuckPopup,
    };
};
export { useStuckStudents };
